module.exports = __webpack_public_path__ + "img/-LV57a2-fHwRkImcqPFS.797d1acd.jpg";